import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {HorribleHeroesGameConfig} from "../../HorribleHeroesGameConfig";
import {HorribleHeroesGameMode} from "../../HorribleHeroesGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SoundManager} from "../../resource/sound/SoundManager";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {PickButton} from "./PickButton";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {HorribleHeroesParsedInitData} from "../../server/data/HorribleHeroesParsedInitData";
import {HorribleHeroesReelController} from "../../reel/HorribleHeroesReelController";
import {HorribleHeroes} from "../../HorribleHeroes";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class HorribleHeroesFreeSpinIntroView extends BaseView implements GameModeTransitionView {
    protected _gameData: HorribleHeroesParsedGameData;
    private _gameMode: string;
    private _expandedSym: string = "";
    private readonly buttonsName: string[] = ["fs_Toxic", "fs_load"];
    private readonly _textPage1: string = "Win more often";
    private readonly _textPage2: string = "High risk, high potential";
    private readonly _volatilityTextStyle: any = {
        fill: 0xffffff,
        fontFamily: "Open Sans",
        wordWrap: true,
        wordWrapWidth: 400,
        fontWeight: FontWeight.BOLD,
        fontSize: 22
    };
    private _buttons: PickButton[];
    private _gameSizeEnteringFreespin: number[];
    private _volatilityBar: PIXI.Container;
    private _highVLogo: PIXI.Sprite;
    private _extremeVLogo: PIXI.Sprite;
    private _isRestore: boolean;
    private XSymbolPositions: number[];
    private _dimmer: PIXI.Sprite;
    private _fsintroTransition: PIXI.spine.Spine;
    private _fsintroTransitionMayhem: PIXI.spine.Spine;
    private _fsintroTransitionFirespark: PIXI.spine.Spine;
    private _layer: PIXI.Container;
    private _isWaiting: boolean = false;
    private _completeCallback: () => void;
    private _replayPlayerSelectionIndex: number = -1;
    private positionsExpandSyms: number[][] = [];
    private InfectiousPos: number[][] = [];
    private noOFExpandedSymOnReel: number[] = [];
    private mysterySymbolSizes: number[] = [];

    constructor(oneTime: boolean) {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesGameConfig.instance.LAYERS.FREE_SPIN.name);
        this._layer.addChild(this);
        if (oneTime) {
            this.addOneTimeEventListeners()
        }
    }

    public prepare(data: HorribleHeroesParsedGameData): void {
        this._gameMode = data.mode;
        this._gameData = <HorribleHeroesParsedGameData>data;
        this._gameSizeEnteringFreespin = data.gameSizeEnteringFreespin;
        if (GameSetting.replayMode) {
            if (data.replayNextPlayerInteraction == null) {
                debugger;
                throw new Error("PickAndClickController.onGameDataParsed() nextPlayerInteraction is missing from the server response when replay!");
            }
            this._replayPlayerSelectionIndex = data.replayNextPlayerInteraction.selectedIndex;
            if (this._replayPlayerSelectionIndex < 0) {
                debugger;
                throw new Error("PickAndClickController.onGameDataParsed() nextPlayerInteraction.selectedIndex is not a valid number!");
            }
        }
    }

    public getEndAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            isMayhemMode: boolean = (this._gameData.mode === HorribleHeroesGameMode.NORMAL && this._gameData.superFSTriggered),
            fsMode: string = (HorribleHeroesGameConfig.instance.SELECTED_INDEX === 2 ? "LocknLoad" : "Toxic"),
            mayhemName: string = (isMayhemMode && fsMode === "LocknLoad") ? "Load" : fsMode;

        tl.add(() => {
            this._dimmer.visible = false;

            this.startEndTransition(isMayhemMode, mayhemName, fsMode);

            // #435, delayed time is taken from the issue
            TweenLite.delayedCall(0.169, () => {
                if (isMayhemMode) {
                    SoundManager.playSuperFreeSpinBGFromMainGame();
                } else {
                    SoundManager.playFreeSpinBG();
                }
            });
        }, 1);
        tl.add(() => this.endEndTransition(isMayhemMode, mayhemName, fsMode), 2.5);

        tl.add(() => this.resetTransitionItems(), 3);

        return tl;
    }

    public getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        this._isWaiting = false;
        this.disableButtons();
        this._completeCallback = completeCallback;
        const tl: TimelineLite = new TimelineLite();

        // #548
        tl.delay(HorribleHeroesGameConfig.instance.WIN_ABORT_DELAY);
        HorribleHeroesGameConfig.instance.WIN_ABORT_DELAY = 0;

        tl.add(() => {
            this._isWaiting = true;
            this._dimmer.alpha = 0;
            this._volatilityBar.alpha = 0;
            this._dimmer.visible = true;
            this._buttons.forEach((button: PickButton) => {
                button.alpha = 0;
                button.visible = true;
                this.addChild(button);
            });
            this.alpha = 1;
            this._layer.addChild(this);
        });
        tl.add([
            new TweenLite(this._dimmer, 0.3, {alpha: 0.6}),
            new TweenLite(this._volatilityBar, 0.3, {alpha: 1})]);
        this._buttons.forEach((button: PickButton, index: number) => {
            tl.add([
                () => button.show(this._gameData.freespinSpinChoices[index], (this._gameData.mode === HorribleHeroesGameMode.NORMAL && this._gameData.superFSTriggered)),
                new TweenLite(button, 0.1, {alpha: 1})
            ], "+=0.2");
        });
        tl.add(() => {
            prepareToEnterModeCallback();
            if (!GameSetting.replayMode) {
                this.enableButtons();
            }
        });
        if (!GameSetting.replayMode) {
            this._buttons.forEach((button: PickButton, index: number) => {
                tl.add(() => button.playIdel(), "+=" + index);
                //at index 0 ==> tl position 0;
                //at index 1 ==> tl position 1;(for right animation)
                //duration for animation is 1sec
                //#363
            });
        }

        if (GameSetting.replayMode) {
            tl.add(this.playReplay());
        }
        return tl;
    }

    protected onResize(resizeData: IResizeData): void {
        this._dimmer.width = resizeData.width + 100;
        this._dimmer.height = resizeData.height + 100;
        const barBottom: number = (resizeData.height >= 700) ? 650 : (resizeData.bottom - 50);
        this._buttons.forEach((button: PickButton, i: number) => {
            button.position.set(360 + resizeData.width * 0.25 * (i > 0 ? 1 : -1), 300);
        });

        this._volatilityBar.scale.set(0.9);
        this._volatilityBar.position.set(360, barBottom);

        // #499
        if (NolimitApplication.isLandscape) {
            this._highVLogo.position.set(-408, -12);
            this._extremeVLogo.position.set(425, -12);
        } else {
            this._highVLogo.position.set(-200, 40);
            this._extremeVLogo.position.set(200, 40);
        }
    }

    protected initAnimations(): void {
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5);
        this._dimmer.position.set(360);
        this._dimmer.tint = 0X000000;
        this._dimmer.visible = false;

        this._fsintroTransition = new PIXI.spine.Spine(GameResources.getSpineAsset("fsintroTransition"));
        this._fsintroTransition.pivot.set(0.5);
        this._fsintroTransition.position.set(360);
        this._fsintroTransition.visible = false;

        this._fsintroTransitionMayhem = new PIXI.spine.Spine(GameResources.getSpineAsset("fsintroTransitionMayhem"));
        this._fsintroTransitionMayhem.pivot.set(0.5);
        this._fsintroTransitionMayhem.position.set(360);
        this._fsintroTransitionMayhem.visible = false;

        this._fsintroTransitionFirespark = new PIXI.spine.Spine(GameResources.getSpineAsset("fsintroTransitionFirespark"));
        this._fsintroTransitionFirespark.pivot.set(0.5);
        this._fsintroTransitionFirespark.position.set(360, 0);
        this._fsintroTransitionFirespark.visible = false;

        this._buttons = ArrayHelper.initArrayWithValues(this.buttonsName.length, (i: number) => {
            return this.createPickButton(i + 1, this.buttonsName[i]);
        });

        this.addChild(this._dimmer);
        this._volatilityBar = this.createVolatilityBar();
        this._volatilityBar.alpha = 0;

        this.addChild(this._volatilityBar, this._fsintroTransition, this._fsintroTransitionMayhem, this._fsintroTransitionFirespark);
    }

    protected startEndTransition(isMayhemMode: boolean, mayhemName: string, fsMode: string): void {
        this.disableButtons();
        if (isMayhemMode) {
            this.resetSpine(this._fsintroTransitionMayhem);
            this._fsintroTransitionMayhem.state.setAnimation(0, "mayhem_" + mayhemName + "Start", false);
        } else {
            this.resetSpine(this._fsintroTransition);
            this._fsintroTransition.state.setAnimation(0, fsMode + "Start", false);
        }

        this.resetSpine(this._fsintroTransitionFirespark);
        this._fsintroTransitionFirespark.state.setAnimation(0, "transitionFirespark", true);

        // #410
        SoundManager.playFSStartDoorClose();
    }

    protected endEndTransition(isMayhemMode: boolean, mayhemName: string, fsMode: string): void {
        this._volatilityBar.alpha = 0;

        if (isMayhemMode) {
            this.resetSpine(this._fsintroTransitionMayhem);
            this._fsintroTransitionMayhem.state.setAnimation(0, "mayhem_" + mayhemName + "End", false);
        } else {
            this.resetSpine(this._fsintroTransition);
            this._fsintroTransition.state.setAnimation(0, fsMode + "End", false);
        }

        this._fsintroTransitionFirespark.visible = false;
        this._fsintroTransitionFirespark.state.clearTracks();

        // #368 -> change background -> moved the call from HorribleHeroesZeroBet.ts to here
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: HorribleHeroesGameMode.FREESPIN_MID}));

        // #410
        SoundManager.playFSStartDoorOpen();

        // #381
        let mode: string = "";
        if (isMayhemMode) {
            mode = "MAYHEM_MODE";
        } else if (fsMode === "LocknLoad") {
            mode = HorribleHeroesGameMode.FREESPIN_MID;
        } else {
            mode = HorribleHeroesGameMode.FREESPIN_LOW;
        }
        HorribleHeroesGameModuleConfig.logoAnimations.showLogo(mode);
    }

    protected resetTransitionItems(): void {
        this._fsintroTransition.visible = false;
        this._fsintroTransition.state.clearTracks();

        this._fsintroTransitionMayhem.visible = false;
        this._fsintroTransitionMayhem.state.clearTracks();

        // #378 -> This will turn off Autoplay if in restricted jurisdiction
        if (HorribleHeroes.autoPlay.turnOffAutoplayOnBonus) {
            HorribleHeroes.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    private addOneTimeEventListeners(): void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onGameReady());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.initGameDataParsed(event.params[0]));
    }

    private initGameDataParsed(data: HorribleHeroesParsedInitData): void {
        //  this._gameAreaSizeBefore = data.getGameAreaSizeBefore;
        this._isRestore = data.isRestoreState;
        this._expandedSym = data.getExpandedSymbol;
        this._gameSizeEnteringFreespin = data!.getGameSizeEnteringFreespin;
        this.XSymbolPositions = data.getXSymbolPositions;
        this.positionsExpandSyms = data.getSymbolSizesPos;
        this.InfectiousPos = data.getInfectiousPos;
        this.noOFExpandedSymOnReel = data.numberOfExpandSymbolOnReel;
        this.mysterySymbolSizes = data.mysterySymbolSizes;
        this._gameMode = data.mode;

        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onGameReady(): void {
        if (this._isRestore) {
            this._isRestore = false;
        }
        if (this._gameSizeEnteringFreespin && (this._gameMode !== HorribleHeroesGameMode.FREESPIN_LOW) && (this._gameMode !== HorribleHeroesGameMode.FREESPIN_MID)) {
            this._gameSizeEnteringFreespin.forEach((value, reelId) => {
                if (value > 4) {
                    if (this.noOFExpandedSymOnReel[reelId] == 1) {
                        let symId: number = -1;
                        if (this.InfectiousPos[reelId].length > 0) {
                            //one infected  sym
                            symId = this.InfectiousPos[reelId][0];
                        } else if (this.XSymbolPositions[reelId] > -1) {
                            //one  X symbol
                            symId = this.XSymbolPositions[reelId];
                        }
                        (<HorribleHeroesReelController>Reels.getReel(reelId)).addExpandingSymbols("X", this.mysterySymbolSizes[reelId], symId);
                        // (<HorribleHeroesReelController>Reels.getReel(reelId)).replaceOtherReelSyms(symId,  this.mysterySymbolSizes[reelId]);
                        (<HorribleHeroesReelController>Reels.getReel(reelId)).conversionXwaySym(this._expandedSym, this.mysterySymbolSizes[reelId], symId, this._gameSizeEnteringFreespin[reelId]);

                    } else if (this.XSymbolPositions[reelId] == -1) {
                        //two infected symbols
                        this.InfectiousPos[reelId].forEach((symId) => {
                            (<HorribleHeroesReelController>Reels.getReel(reelId)).revealXwaySym(this._expandedSym, this.mysterySymbolSizes[reelId], symId, this._gameSizeEnteringFreespin[reelId], true, true, true)
                        })
                    } else {
                        //one X and one infected
                        (<HorribleHeroesReelController>Reels.getReel(reelId)).addExpandingSymbols("X", this.mysterySymbolSizes[reelId], this.XSymbolPositions[reelId]);
                        (<HorribleHeroesReelController>Reels.getReel(reelId)).addExtraExpandingSymbols(this._expandedSym, this.mysterySymbolSizes[reelId], this.InfectiousPos[reelId][0], this._gameSizeEnteringFreespin[reelId], this.positionsExpandSyms)

                    }
                }
            })
        }
    }

    private createPickButton(id: number, name: string): PickButton {
        const btn: PickButton = new PickButton(name, () => {
            this.playClick(id);
        });
        btn.createAnimation();
        btn.enabled = false;
        btn.visible = false;
        btn.anchor.set(0.5, 0.5);
        btn.y = -20;
        btn.scale.set(1);
        return btn;
    }

    private createVolatilityBar(): PIXI.Container {
        const container: PIXI.Container = new PIXI.Container();
        this._highVLogo = new PIXI.Sprite(GameResources.getTextures("volatilityHigh")[0]);
        this._highVLogo.anchor.set(0.5);
        this._extremeVLogo = new PIXI.Sprite(GameResources.getTextures("volatilityExtreme")[0]);
        this._extremeVLogo.anchor.set(0.5);

        const bar: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bar")[0]);
        bar.anchor.set(0.5);
        container.addChild(bar);

        let textMinScale: number = 1;
        const text1: PIXI.Text = new PIXI.Text(HorribleHeroes.api.translations.translate(this._textPage2), this._volatilityTextStyle);
        text1.anchor.set(1, 1);
        text1.position.set(320, -12);
        container.addChild(text1);
        if (text1.width > 300) {
            textMinScale = Math.min(textMinScale, MathHelper.roundToDecimals(300 / text1.width, 2));
        }

        const text2: PIXI.Text = new PIXI.Text(HorribleHeroes.api.translations.translate(this._textPage1), this._volatilityTextStyle);
        text2.anchor.set(0, 1);
        text2.position.set(-290, -12);
        container.addChild(text2);
        if (text2.width > 300) {
            textMinScale = Math.min(textMinScale, MathHelper.roundToDecimals(300 / text2.width, 2));
        }

        if (textMinScale < 1) {
            text1.scale.set(textMinScale);
            text2.scale.set(textMinScale);
        }

        container.addChild(this._highVLogo, this._extremeVLogo);

        return container;
    }

    private playClick(id: number): void {
        id = parseInt(id + ""); // #408 -> server sends out this as string but in framework it's type is string

        const buttonActive: PickButton = this._buttons[id - 1];
        const buttonDeactive: PickButton = this._buttons[id % 2];
        buttonActive.enabled = false;
        buttonDeactive.enabled = false;
        HorribleHeroesGameConfig.instance.SELECTED_INDEX = id;
        this._completeCallback();
        const buttonBounce: TimelineLite = new TimelineLite();
        buttonBounce.to(buttonActive.scale, 0.06, {x: 0.8, y: 0.8})
            .to(buttonActive.scale, 0.1, {x: 1, y: 1});
        buttonDeactive.playUnselectedTint();

        // #410
        SoundManager.playFSSelect();
    }

    private enableButtons(): void {
        this._buttons.forEach((button: PickButton) => {
            button.enabled = true;
        });
    }

    private disableButtons(): void {
        this._buttons.forEach((button: PickButton) => {
            button.visible = false;
            button.enabled = false;
            button.reset();
        });
    }

    private playReplay(): TimelineLite {
        const id: number = this._replayPlayerSelectionIndex;
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._buttons[1].enabled = false;
            this._buttons[0].enabled = false;
            const buttonActive: PickButton = this._buttons[id - 1];
            const buttonDeactive: PickButton = this._buttons[id % 2];
            buttonActive.enabled = false;
            buttonDeactive.enabled = false;
            buttonActive.playClick();
        });
        tl.add(() => {
            this.playClick(id);
        }, 1);
        return tl;
    }

    private resetSpine(item: PIXI.spine.Spine): void {
        if (!item.visible) {
            item.updateTransform();
            item.visible = true;
        }

        item.state.clearTracks();
        item.state.setEmptyAnimation(0, 0);
        item.skeleton.setSlotsToSetupPose();
        item.skeleton.setToSetupPose();
    }
}
